import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LinkButton from 'flarum/common/components/LinkButton';
import BadmintonTradesBoard from './BadmintonTradesBoard';
import { maybeShowBadmintonTradesAnnounce } from './BadmintonTradesAnnounce';

/**
 * 全屏「场地交易」独立路由页（非弹窗）
 */
export default class BadmintonTradesPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.history.push('acme.badminton.trades', '场地交易');
    this.bodyClass = 'App--badminton-trades';
  }

  view() {
    return (
      <div className="BadmintonTradesPage">
        <div className="container BadmintonTradesPage-inner">
          <header className="BadmintonTradesPage-header">
            <LinkButton href={app.route('index')} icon="fas fa-arrow-left">
              查看最新资讯
            </LinkButton>
            <h1 className="BadmintonTradesPage-heading">场地交易</h1>
          </header>
          <BadmintonTradesBoard />
        </div>
      </div>
    );
  }

  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('场地交易');
    requestAnimationFrame(() => maybeShowBadmintonTradesAnnounce());
  }
}
